<template>
  <gj-modal
      :visible.sync="modalVisible"
      :loading="modalLoading"
      size="full"
  >
    <template #header>生成发货单</template>
    <template #content>
      <app-shipment-bill-header-info
          ref="headerInfo"
          :header-info-data="headerInfoData"
          :item="item"></app-shipment-bill-header-info>
      <app-shipment-bill-product-detail
          ref="productDetail"
          :product-items="productItems"
          :item="item" ></app-shipment-bill-product-detail>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <template v-if="isMeaningful(item) && $permission('shipNote:abolish')">
        <gj-button @click="abolished">作废</gj-button>
      </template>
      <template v-else>
        <template v-if="$permission('shipNote:shipped')">
          <gj-button :loading="confirmLoading" @click="waitShipment" type="primary" plain>等待出运</gj-button>
        </template>
      </template>
      <template v-if="$permission('shipNote:shipped')">
        <gj-button :loading="confirmLoading" @click="confirmShipment" type="primary">确认出运</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, modalMixIn, responseMixin} from "@/minxins";
  import AppShipmentBillLogisticsFee from './shipment-bill-logistics-fee';
  import AppShipmentBillHeaderInfo from "./shipment-bill-header-info";
  import AppShipmentBillProductDetail from "./shipment-bill-product-detail";
  import {isMeaningful} from "@/utils/common";
  import {
    generateSaveShipped,
    generateSaveWaitShipped,
    getGenerateShipNoteProductItem,
    getShipNoteDetail, shipNoteAbolished, updateShipNote
  } from "@/api/logistics";
  import {convertToDate} from "@/utils/date.util";

  export default {
    name: "app-generate-shipment",
    components: {AppShipmentBillProductDetail, AppShipmentBillHeaderInfo},
    mixins: [modalMixIn, formRuleMixin, isMeaningfulMixin, responseMixin],
    props: {
      shipmentIds: null,
      item: null,
    },
    created() {
      if (isMeaningful(this.item)) {
        getShipNoteDetail(this.item.id)
          .then((data) => {
            this.productItems = data.productItemList;
            this.headerInfoData = data;
          }).complete(() => this.modalLoading = false)
      } else {
        getGenerateShipNoteProductItem(this.shipmentIds)
          .then((data) => {
            this.productItems = data;
          }).complete(() => this.modalLoading = false)
      }
    },
    data() {
      return {
        modalLoading: true,
        productItems: [],
        headerInfoData: null,
      }
    },
    methods: {
      waitShipment() {
        if (this.$refs.headerInfo.$gjFormValidate() & this.$refs.productDetail.$gjFormValidate()) {
          const modal = this.$gjCreate('gj-info-modal', {
            props: {
              content: `确认等待出运？<br/>该发货单状态将更新为“待出运”！`
            },
            on: {
              cancel: () => modal.$gjDestroy(),
              confirm: () => {
                modal.confirmLoading = true;
                generateSaveWaitShipped(this.getSaveParams())
                  .then((res) => {
                    this.$gjResponseHandle(res, () => {
                      this.$gjMessage.success('操作成功');
                      modal.$gjDestroy();
                      this.$emit('after');
                    })
                  }).complete(() => modal.confirmLoading = false);
              }
            }
          })
        }
      },
      confirmShipment() {
        if (this.$refs.headerInfo.$gjFormValidate() & this.$refs.productDetail.$gjFormValidate()) {
          this.confirmLoading = true;
          if (isMeaningful(this.item)) {
            updateShipNote(this.getSaveParams())
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  if (this.$permission('shipNote:logisticsFee')) {
                    this.$gjCreate(AppShipmentBillLogisticsFee, {
                      props: {
                        code: this.headerInfoData.code,
                        productItems: this.$refs.productDetail.form.items,
                      },
                      on: {
                        modalCancel: () => {
                          this.$emit('after');
                        }
                      }
                    })
                  } else {
                    this.$gjMessage.success('操作成功');
                    this.$emit('after');
                  }
                })
              }).complete(() => this.confirmLoading = false)
          } else {
            generateSaveShipped(this.getSaveParams())
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  if (this.$permission('shipNote:logisticsFee')) {
                    this.$gjCreate(AppShipmentBillLogisticsFee, {
                      props: {
                        code: res.data,
                        productItems: this.$refs.productDetail.form.items,
                      },
                      on: {
                        modalCancel: () => {
                          this.$emit('after');
                        }
                      }
                    })
                  } else {
                    this.$gjMessage.success('操作成功');
                    this.$emit('after');
                  }
                })
              }).complete(() => this.confirmLoading = false)
          }
        }
      },
      abolished() {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `作废<span class="modal-secondary-title">${this.item.code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '18px 40px 4px 30px'}
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              shipNoteAbolished({id: this.item.id, memo: reason})
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('after');
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      },
      getSaveParams() {
        const headerInfoForm = this.$refs.headerInfo.form;
        let productDetailForm = this.$refs.productDetail.form.items;
        productDetailForm = productDetailForm.filter(v => v.shipQuantity !== 0 && v.shipQuantity !== '0');
        productDetailForm.forEach( v => {
          v.expectSignDate = convertToDate(v.expectSignDate);
          v.transferItemIds = (v.shipTransferItemVOList || []).map(k => k.transferItemId);
          v.updateSubDTOList = (v.shipTransferItemVOList || []).map(k => {
            return {
              ...k,
              type: 'DB',
              relevanceItemId: k.transferItemId
            }
          })
        });
        return {
          id: isMeaningful(this.item) ? this.item.id : null,
          ...headerInfoForm,
          expectArrivalDate: convertToDate(headerInfoForm.expectArrivalDate),
          expectShipDate: convertToDate(headerInfoForm.expectShipDate),
          shipNoteItemList: productDetailForm
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .not-form-item-mgb {
    margin-bottom: 0;
  }
  /deep/ .gj-modal--full .el-dialog {
    width: 1366px !important;
  }
  /deep/ .el-dialog__body{
    padding: 16px 20px 0;
  }
</style>
